import { handleInputChange } from 'components/global/_helpers/global.helpers';
import ProfileImageUpload from 'components/global/ProfileImageUpload';
import UniversalInput from 'components/global/UniversalInput';
import { handleProfileImageRemove, handleProfileImageUpload, handleSubmitProfileEdit } from 'components/views/FounderEditProfile/_helpers/founderEditProfile.events';
import { fetchAndSetFounderProfileData } from 'components/views/FounderEditProfile/_helpers/founderEditProfile.resolvers';
import withDismount from 'hocs/withDismount';
import { Button, Col, Row } from 'react-bootstrap';
import { $form, $user, $view } from 'signals/global.signals';
import useCleanup from 'utils/useCleanup';
import { useEffectAsync } from 'utils/useEffectAsync';

const FounderEditProfile = () => {
  useCleanup($view);
  useEffectAsync(fetchAndSetFounderProfileData);

  return (
    <>
      <Row className="mb-32">
        <Col>
          <div className="d-flex flex-md-row flex-column align-items-center">
            <div>
              <ProfileImageUpload
                entityId={$user.value.id}
                currentImage={$form.value.profileImage}
                defaultName={$form.value.firstName}
                avatarColors={$form.value.avatarColors}
                onImageUpload={handleProfileImageUpload}
                onImageRemove={handleProfileImageRemove}
                uploadPath="profile-assets"
              />
            </div>
            <div className="d-flex flex-column ms-md-32 ms-0 align-items-md-start align-items-center">
              <div>
                <span className="d-block h3 fw-600">{$user.value.firstName} {$user.value.lastName}</span>
                <span className="text-info d-block">{$user.value.email}</span>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <Row className="gx-xl-24 gx-md-16 gx-24 gy-lg-16 gy-16">
        <Col lg={6} md={6}>
          <UniversalInput
            name="firstName"
            value={$form.value.firstName}
            label="First Name"
            placeholder="First Name"
          />
        </Col>
        <Col lg={6} md={6}>
          <UniversalInput
            name="lastName"
            value={$form.value.lastName}
            label="Last Name"
            placeholder="Last Name"
          />
        </Col>
        <Col lg={6} md={6}>
          <UniversalInput
            type="select"
            name="age"
            label="Select your age range"
            value={$form.value.age}
            options={$view.value.ageOptions || []}
          />
        </Col>
        <Col lg={6} md={6}>
          <UniversalInput
            type="select"
            name="gender"
            label="Select the gender which best describes you"
            value={$form.value.gender}
            options={$view.value.genderOptions || []}
          />
        </Col>
        <Col lg={6} md={6}>
          <UniversalInput
            type="select"
            name="ethnicity"
            label="Select your ethnicity"
            value={$form.value.ethnicity}
            options={$view.value.ethnicityOptions || []}
          />
        </Col>
        <Col lg={6} md={6}>
          <UniversalInput
            isMulti
            name="roles"
            label="Organization Roles (Select All That Apply)"
            type="select"
            value={$view.value.roleOptions?.filter(option => $form.value.roles?.includes(option.value))}
            options={$view.value.roleOptions}
            onChange={(selectedOptions) => {
              const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
              handleInputChange({ name: 'roles', value: selectedValues });
            }}
          />
        </Col>
      </Row>
      <Row className="mt-24">
        <Col>
          <div className="d-flex gap-16">
            <Button
              className="fw-600 px-24 py-8"
              onClick={handleSubmitProfileEdit}
              disabled={$view.value.isFormSaving}
            >
              Save Changes
            </Button>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default withDismount(FounderEditProfile);
